import { render, staticRenderFns } from "./SettingsPaymentCustomerForm.vue?vue&type=template&id=292fd1e3"
import script from "./SettingsPaymentCustomerForm.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentCustomerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports